import { Container, Flex, Divider, Box, Text } from '@chakra-ui/react';
import React from 'react';
import ArrowLeft from '../icons/ArrowLeft';

const PageHeader = ({ title }: { title: string }) => {
  return (
    <Box
      background='#ffffff'
      position='fixed'
      top={0}
      left={0}
      width='full'
      zIndex={2}
    >
      <Container>
        <Flex alignItems='center' m='auto' columnGap={3} height='65px'>
          <ArrowLeft
            stroke='#1e293b'
            boxSize='24px'
            onClick={() => window.history.back()}
          />
          <Text fontSize='xl' fontWeight='semibold'>
            {title}
          </Text>
        </Flex>
        <Divider />
      </Container>
    </Box>
  );
};

export default PageHeader;
